import React, { useMemo } from "react";
import { Donut as SuiteDonut, DonutLabels, DonutLegend, Tooltip, Text } from "@foris/avocado-suite";
import { AdaptedGroup } from "../../models";
import donut, { DonutRow } from "../../utils/donut";
import css from "./donut.module.scss";

interface IProps {
  group: Partial<AdaptedGroup>;
  padding?: string;
  rows?: DonutRow[];
  donutWidth?: string;
  donutHeight?: string;
  hasTooltip?: boolean;
}

const Donut = (props: IProps) => {
  const {
    group,
    padding,
    rows = [],
    donutHeight = "48px",
    donutWidth = "48px",
    hasTooltip = true,
  } = props;
  const adaptedRows = useMemo(
    () =>
      rows?.length
        ? rows?.map(row => {
            const adaptedRow = {};

            Object.entries(row).forEach(([key, value]) => {
              const adaptedValue = Number.isNaN(value) || value === Infinity ? 0 : value;
              adaptedRow[key] = adaptedValue;
            });

            return adaptedRow;
          })
        : [],
    [rows],
  );

  const donutRows: any = adaptedRows?.length ? adaptedRows : donut(group);

  return (
    <div
      className={css.donut}
      style={{
        display: "flex",
        alignItems: "center",
        padding: Boolean(padding) ? padding : "0",
      }}
    >
      <SuiteDonut
        className={css.dataCircle}
        width={donutWidth}
        height={donutHeight}
        data={donutRows}
      />

      <Tooltip
        label={
          <div className={css.tooltipContent}>
            <Text>Referencia de colores</Text>

            <DonutLegend data={donutRows} className={css.legend} />
          </div>
        }
        placement="top"
        className={css.tooltip}
        visible={hasTooltip ? undefined : false}
      >
        <DonutLabels className={css.dataLabels} data={donutRows} />
      </Tooltip>
    </div>
  );
};

export default Donut;
